import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react'; 

const Sale = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: { xs: 'auto', md: '50vh' },
        width: '100%',             // 100% adapts to the parent without including the scrollbar
        overflow: 'hidden',        // Hides any overlapping background blobs
        boxSizing: 'border-box',
        margin: 'auto',
        background: 'linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%)',
        textAlign: 'center',
        color: '#fff',
        py: { xs: 8, md: 10 },
        px: 2,
      }}
    >
      {/* Abstract Background Decoration 1 */}
      <Box
        sx={{
          position: 'absolute',
          top: '-50%',
          right: '-10%',
          width: '600px',
          height: '600px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0) 70%)',
          zIndex: 0,
          pointerEvents: 'none',
        }}
      />
      
      {/* Abstract Background Decoration 2 */}
      <Box
        sx={{
          position: 'absolute',
          bottom: '-50%',
          left: '-10%',
          width: '500px',
          height: '500px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 70%)',
          zIndex: 0,
          pointerEvents: 'none',
        }}
      />

      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        
        {/* Small accent badge */}
        <Box 
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1, 
            bgcolor: 'rgba(255, 255, 255, 0.2)', 
            px: 2, 
            py: 0.75, 
            borderRadius: '999px',
            mb: 3,
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.3)'
          }}
        >
          <Sparkles size={16} color="white" />
          <Typography sx={{ fontSize: '0.85rem', fontWeight: 600, letterSpacing: '0.05em', textTransform: 'uppercase' }}>
            Limited Time Offer
          </Typography>
        </Box>

        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4rem' },
            lineHeight: 1.1,
            letterSpacing: '-0.02em',
            fontWeight: 800,
            color: 'white',
            mb: 2,
            textTransform: 'uppercase'
          }}
        >
          Buy 1 year and <br />
          <Box component="span" sx={{ color: '#FDE047' }}>save 10%</Box>
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: '1rem', md: '1.25rem' },
            color: 'rgba(255, 255, 255, 0.9)',
            mb: 5,
            maxWidth: '600px',
            lineHeight: 1.6
          }}
        >
          Secure & simple online accounting that saves you time. Upgrade today and unlock the full potential of your business.
        </Typography>

        <Button
          onClick={() => navigate('/payment')}
          endIcon={<ArrowRight size={20} />}
          sx={{
            padding: '14px 32px',
            fontSize: '1.1rem',
            borderRadius: '999px',
            width: { xs: '100%', sm: 'auto' }, 
            minWidth: '250px',
            fontWeight: 700,
            color: '#4F46E5', 
            backgroundColor: '#ffffff', 
            textTransform: 'none',
            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.2)',
            transition: 'all 0.3s ease',
            '&:hover': {
              backgroundColor: '#F8FAFC',
              transform: 'translateY(-3px)',
              boxShadow: '0 20px 30px -5px rgba(0, 0, 0, 0.3)',
            },
          }}
        >
          Buy Now
        </Button>
      </Container>
    </Box>
  );
};

export default Sale;